import { render, staticRenderFns } from "./AMEI_Supports.vue?vue&type=template&id=2985aa92&scoped=true"
import script from "./AMEI_Supports.vue?vue&type=script&lang=js"
export * from "./AMEI_Supports.vue?vue&type=script&lang=js"
import style0 from "./AMEI_Supports.vue?vue&type=style&index=0&id=2985aa92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2985aa92",
  null
  
)

export default component.exports